/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useMemo, memo, useState } from 'react';
import { Button } from 'reactstrap';
import Table from '../../Table';
import CustomSpinner from '../../Spinner/CustomSpinner';
import './styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const ManagerCGM = memo(({ seletedManagers, onDelete, loading }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData([...seletedManagers]);
  }, [seletedManagers]);

  const column = useMemo(
    () => [
      {
        dataIndex: 'email',
        label: 'Email',
        sort: (a, b) => {
          if (a.email < b.email) {
            return -1;
          }
          if (a.email > b.email) {
            return 1;
          }
          return 0;
        },
      },
      {
        dataIndex: 'action',
        label: 'Action',
        render: (_, datum, index) => {
          return (
            <Button outline color="danger" onClick={() => onDelete(datum, index)}>
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          );
        },
      },
    ],
    [data],
  );
  if (data)
    return (
      <div className="mt-3">
        {loading ? (
          <>
            <div className="set-height">
              <CustomSpinner />
            </div>
          </>
        ) : (
          <>
            <Table data={data} column={column} showPagination />
            <div className="mt-3 color-grey">
              <p>Total Users in Group: {seletedManagers?.length}</p>
            </div>
          </>
        )}
      </div>
    );
  else return null;
});

export default ManagerCGM;
